// Generated by CoffeeScript 1.12.7
(function () {
  var CustomLabelsEditor;

  module.exports = CustomLabelsEditor = (function () {
    function CustomLabelsEditor(createUi, usingFeature, labelSet, labelService, overlayStack, onDone) {
      var defaultFields, fieldOrder, recurringPricingFieldOrder;
      defaultFields = labelService.getDefaultFields();
      fieldOrder = [
        "section",
        "total",
        "subTotal",
        "excludingTax",
        "discount",
        "percentageOff",
        "description",
        "item",
        "quantity",
        "price",
        "per",
        "select",
        "selected",
        "recommended",
        "oneOffAdjective",
      ];
      recurringPricingFieldOrder = [
        "dueToday",
        "dueTodayExcludingTax",
        "oneOff",
        "recurring",
        "weekNoun",
        "weekAdjective",
        "monthNoun",
        "monthAdjective",
        "quarterNoun",
        "quarterAdjective",
        "yearNoun",
        "yearAdjective",
      ];
      fieldOrder = fieldOrder.concat(recurringPricingFieldOrder);
      this.ui = createUi(require("./CustomLabelsEditor.html"), {
        name: labelSet.name,
        defaultFields: defaultFields,
        fieldOrder: fieldOrder,
        labels: labelSet.labels,
        done: (function (_this) {
          return function () {
            labelSet.name = _this.ui.name;
            return onDone(labelSet.id, labelSet);
          };
        })(this),
        goBack: overlayStack.closeCurrent,
        closeOverlay: overlayStack.closeAll,
      });
    }

    return CustomLabelsEditor;
  })();
}.call(this));
